import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React from 'react';
import styles from './loader.module.scss';
export const LoaderIndicator = ({ ...rest }) => (React.createElement(LoadingIndicator.Global, { className: styles.fullScreenLoader, ...rest },
    React.createElement(React.Fragment, null)));
//# sourceMappingURL=index.js.map